import { create } from 'zustand'
import { v4 as uuidv4 } from 'uuid'
import type { ToastMessage, ToastType } from '../types'

interface AdminState {
  // Toasts
  toasts: ToastMessage[]
  addToast: (type: ToastType, message: string) => void
  removeToast: (id: string) => void
}

export const useAdminStore = create<AdminState>((set) => ({
  toasts: [],

  addToast(type, message) {
    const id = uuidv4()
    set((s) => ({ toasts: [...s.toasts, { id, type, message }] }))
    // Auto-dismiss after 5 s
    setTimeout(() => set((s) => ({
      toasts: s.toasts.filter((t) => t.id !== id),
    })), 5000)
  },

  removeToast(id) {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
  },
}))

/** Convenience helpers */
export const toast = {
  success: (msg: string) => useAdminStore.getState().addToast('success', msg),
  error:   (msg: string) => useAdminStore.getState().addToast('error',   msg),
  info:    (msg: string) => useAdminStore.getState().addToast('info',    msg),
  warning: (msg: string) => useAdminStore.getState().addToast('warning', msg),
}
